module.exports = "/images/kn.svg?6da070da4f62487b73ea235818819f6a";